import { render, staticRenderFns } from "./newDictionary.vue?vue&type=template&id=5e2f108f&scoped=true"
import script from "./newDictionary.vue?vue&type=script&lang=js"
export * from "./newDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f108f",
  null
  
)

/* custom blocks */
import block0 from "./newDictionary.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports